<template>
  <hm-content title="">
    <div>
      <div class="line-title">导购档案</div>
      <div class="flex item-center mt20">
        <el-input
          clearable
          style="width: 400px"
          v-model.trim="searchCondition.keyWord"
          placeholder="请输入要查询的姓名/手机号/身份证号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      <div class="search-tips mt10" v-if="list && list.length > 1">
        查询出多条记录，请选择您要查看的导购档案
      </div>
      <div class="history mt20">
        <div class="line-title">搜索历史</div>
        <div class="flex mt10" v-if="historyList && historyList.length">
          <div
            class="history-item"
            v-for="(v, i) in historyList"
            :key="i"
            :class="{ 'history-item-green' : v.funcResult === 'yes'}"
            @click="historyClick(v.fuzzyCustomerKeyWords)"
          >
            {{ v.fuzzyCustomerKeyWords }}
          </div>
        </div>
      </div>
      <div class="mt20" v-if="list && list.length">
        <el-table
          stripe
          border
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guider_name"
            label="导购/实名姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guider_phone"
            label="授权手机号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard_name"
            label="实名身份证姓名"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.idcard_name">
                {{ scope.row.idcard_name }}
              </div>
              <div v-else class="danger">未实名</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard_no"
            label="实名身份证号"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.idcard_no">{{ scope.row.idcard_no }}</div>
              <div v-else class="danger">未实名</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="操作"
          >
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="detail(scope.row)"
                  >查看档案</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChanges"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div> -->
      </div>
      <div class="empty flex flex-center item-center" v-else>
        <div class="in">
          <span>当前暂无记录，请输入要查询的信息</span>
        </div>
      </div>
    </div>
  </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchCondition: {
        keyWord: "",
      },
      list: [],
      historyList: [],
    };
  },
  created() {
    this.queryCollectQueryList();
  },
  mounted() {},
  methods: {
    async queryList() {
      console.log("queryList");
      let dynamicQueryCondition = {
        fuzzyCustomerKeyWords: this.searchCondition.keyWord,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "FUZZY_CUSTOMER_KEY_WORDS_QUERY",
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        this.list = result.dataList;
      }
    },
    async search() {
      if(this.searchCondition.keyWord){
        await this.queryList();
        await this.queryCollectQueryList();
      }else{
        this.$message({
          type: "warning",
          message: "请输入搜索条件"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    detail(row) {
      this.$router.push({
        name: "ArchivesDetails",
        query: {
          customerId: row.customer_id
        },
      });
    },
    historyClick(word) {
      this.searchCondition.keyWord = word;
      this.queryList();
    },
    async queryCollectQueryList() {
      console.log("queryCollectQueryList");
      let params = {
        accountId: "",
        accountType: "",
        funcId: "17c8b0eb4b7b617dc4061851932a2398",
        funcType: "collectQueryValue",
        moduleType: "ssr",
        queryRowsLimit: 5,
      };
      const { result } = await this.$store.dispatch(
        "queryCollectQueryList",
        params
      );
      if (result) {
        if (result.dataList) {
          this.historyList = result.dataList;
          this.historyList.forEach((v) => {
            v.fuzzyCustomerKeyWords = JSON.parse(
              v.funcValue
            ).fuzzyCustomerKeyWords;
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.p30 {
  padding: 30px;
}
.line-title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
  }
}
.search-tips {
  color: #e50065;
}
.empty {
  height: 50vh;
  .in {
    align-self: center;
  }
}
.history {
  .history-item {
    padding: 10px;
    background: #dddddd;
    border: solid 1px #666666;
    border-radius: 20px;
    margin-right: 10px;
  }
  .history-item-green{
    color: #FFFFFF;
    background: #008a00;
    border: solid 1px #008a00;
  }
}
</style>